const POST_LOGIN_REDIRECT_KEY = 'backrs_post_login_redirect';

export const setPostLoginRedirect = (path: string): void => {
  localStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
};

// Returns the stored destination once, clearing it so it can't fire on a later login.
export const consumePostLoginRedirect = (): string | null => {
  const path = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);

  if (path) localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);

  return path;
};
